import Modal from "./Modal";

import TerritoryEditor from "../editors/TerritoryEditor";

const TerritoryModal = ({
  projectId,
  syndicationId,
  territoryId,
  territories,
  users,
  open,
  onClose,
  onSave,
  onDelete,
}) => {
  return (
    <Modal
      title={territoryId ? "territory_update" : "territory_new"}
      open={open}
      onClose={onClose}
    >
      <TerritoryEditor
        projectId={projectId}
        syndicationId={syndicationId}
        territoryId={territoryId}
        territories={territories}
        users={users}
        onSave={onSave}
        onDelete={onDelete}
      />
    </Modal>
  );
};

export default TerritoryModal;
